// Module
var code = "<div data-ng-show=\"message[state]\" data-alert data-ng-class=\"state === 'info' ? 'success' : 'alert'\" class=\"alert-box\"> {{message[state]}} <span class=\"finish\" data-ng-click=\"message[state] = ''\">×</span> </div>";
// Exports
export default code;